import React, { useEffect, useState } from 'react';
import { getMonthlyCategories } from '../api';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatCurrency } from '../utils/formatCurrency';

const COLORS = [
  "#1976d2", "#43a047", "#e53935", "#fb8c00", "#8e24aa",
  "#00acc1", "#f4511e", "#6d4c41", "#3949ab", "#00897b",
  "#c0ca33", "#5e35b1"
];

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const { name, value } = payload[0];
  return (
    <div style={{
      background: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: 8,
      padding: "10px 14px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
      fontSize: 13
    }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{name}</div>
      <div style={{ color: "#555" }}>{formatCurrency(value)}</div>
    </div>
  );
}

function CustomLabel({ cx, cy, midAngle, innerRadius, outerRadius, percent }) {
  if (percent < 0.04) return null;
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 0.55;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="#fff" textAnchor="middle" dominantBaseline="central"
      style={{ fontSize: 12, fontWeight: 600 }}>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
}

export default function ExpensesChart({ month, refreshKey, onSelectCategory }) {
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getMonthlyCategories(month);
        setData(res.data.map(item => ({ ...item, amount: Number(item.amount) })));
      } catch (err) {
        console.error('Erreur camembert:', err);
      }
    };
    if (month) fetchData();
  }, [month, refreshKey]);

  if (!data.length) return null;

  const total = data.reduce((s, d) => s + d.amount, 0);

  return (
    <div>
      <h2 style={{ marginBottom: 4 }}>Dépenses par catégorie</h2>
      <div style={{ color: "#888", fontSize: 13, marginBottom: 16 }}>
        Total : {formatCurrency(total)} — cliquer une catégorie pour voir le détail
      </div>

      <ResponsiveContainer width="100%" height={320}>
        <PieChart>
          <Pie
            data={data}
            dataKey="amount"
            nameKey="category"
            cx="50%"
            cy="50%"
            outerRadius={130}
            innerRadius={50}
            paddingAngle={2}
            labelLine={false}
            label={<CustomLabel />}
            onClick={(entry, index) => {
              setActiveIndex(index);
              onSelectCategory?.(data[index].category);
            }}
            style={{ cursor: "pointer" }}
          >
            {data.map((entry, index) => (
              <Cell
                key={index}
                fill={COLORS[index % COLORS.length]}
                opacity={activeIndex === null || activeIndex === index ? 1 : 0.45}
                stroke={activeIndex === index ? "#fff" : "none"}
                strokeWidth={2}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend
            iconType="circle"
            iconSize={10}
            formatter={(value) => (
              <span style={{ fontSize: 13, color: "#444" }}>{value}</span>
            )}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
